import { defineMessages } from 'react-intl';

export const sharedText = defineMessages({
	siteTitle: {
		id: 'Shared_SiteName',
		defaultMessage: 'Online Custody and Control System'
	},
	login: {
		id: 'Login_LoginBtn',
		defaultMessage: 'Log In'
	},
	confirmDelete: {
		id: 'CollectionDashboard_RemoveQuestion',
		defaultMessage: 'Are you sure you want to remove this collection?'
	},
	cannotBeUndone: {
		id: 'CcfPwa_ThisActionCannotBeUndone',
		defaultMessage: 'This action cannot be undone.'
	},
	yesDelete: {
		id: 'CcfPwa_YesDelete',
		defaultMessage: 'Yes, delete'
	},
	noCancel: {
		id: 'CcfPwa_NoReturnToCollection',
		defaultMessage: 'No, return to collection'
	},
	syncing: {
		id: 'CcfPwa_Syncing',
		defaultMessage: 'Syncing...'
	},
	lastUpdated: {
		id: 'CcfPwa_LastUpdated',
		defaultMessage: 'Last updated:'
	},
	confirmExit: {
		id: 'CcfPwa_AreYouSureYouWantToSaveAndExit',
		defaultMessage: 'Are you sure you want to save and exit?'
	},
	haventFinishedCollection: {
		id: 'CcfPwa_NotYetFinishedCollection',
		defaultMessage: 'You have not yet finished this collection. Are you sure you want to save and exit?'
	},
	yesSaveAndExit: {
		id: 'CcfPwa_YesSaveAndExit',
		defaultMessage: 'Yes, save and exit'
	},
	cancel: {
		id: 'Shared_UserPinCancelBtn',
		defaultMessage: 'Cancel'
	},
	required: {
		id: 'Shared_Required',
		defaultMessage: 'Required'
	},
	collectionsLastDownloaded: {
		id: 'CcfPwa_CollectionsLastDownloaded',
		defaultMessage: 'Collections last downloaded:'
	},
	never: {
		id: 'Shared_NeverLabel',
		defaultMessage: 'Never'
	},
	downloadFromServer: {
		id: 'CcfPwa_DownloadFromServer',
		defaultMessage: 'Download From Server'
	},
	all: {
		id: 'Shared_AllLabel',
		defaultMessage: 'All'
	},
	unsyncedChanges: {
		id: 'CcfPwa_UnsyncedChangesLabel',
		defaultMessage: 'Collections Not Sent to Server'
	},
	incompleteCollections: {
		id: 'CcfPwa_IncompleteCollectionsLabel',
		defaultMessage: 'Incomplete Collections'
	},
	erroredCollections: {
		id: 'CcfPwa_ErroredCollectionsLabel',
		defaultMessage: 'Errored'
	},
	next: {
		id: 'Shared_NextLabel',
		defaultMessage: 'Next'
	},
	download: {
		id: 'Shared_DownloadLabel',
		defaultMessage: 'Download'
	},
	previous: {
		id: 'Shared_PreviousLabel',
		defaultMessage: 'Previous'
	},
	ccfSummary: {
		id: 'NewCcf_CcfSummary',
		defaultMessage: 'Chain of Custody Summary'
	},
	requestingAgency: {
		id: 'CollectionDashboard_RequestingAgency_trp',
		defaultMessage: 'Requesting Agency'
	},
	collectionSite: {
		id: 'CollectionDashboard_RequestingAgency_OtherCollectionSite',
		defaultMessage: 'Collection Site'
	},
	medicalInformation: {
		id: 'NewCcf_MroInformationHeader',
		defaultMessage: 'Medical Information'
	},
	donorName: {
		id: 'CocReportForm_TestResults_DonorName',
		defaultMessage: 'Donor Name:'
	},
	donorId: {
		id: 'CcfPwa_DonorIdLabel',
		defaultMessage: 'Donor ID Number:'
	},
	donorDob: {
		id: 'NewCcf_DonorDob',
		defaultMessage: 'Date of Birth:'
	},
	testsToPerform: {
		id: 'NewCcf_TestType',
		defaultMessage: 'Drug Tests to be Performed:'
	},
	reasonForTest: {
		id: 'NewCcf_TestReason',
		defaultMessage: 'Reason for Test:'
	},
	specimenType: {
		id: 'NewCcf_SampleType',
		defaultMessage: 'Specimen Type:'
	},
	collectionDateAndTime: {
		id: 'NewCcf_CollectionDateTime',
		defaultMessage: 'Collection Date and Time:'
	},
	scanSpecimenId: {
		id: 'NewCcf_ScanSpecimenId',
		defaultMessage: 'Enter/Scan Specimen ID:'
	},
	deliveryService: {
		id: 'NewCcf_DeliveryService',
		defaultMessage: 'Delivery Service:'
	},
	collectionNotes: {
		id: 'NewCcf_Comments',
		defaultMessage: 'Collection Notes:'
	},
	staySignedIn: {
		id: 'CcfPwa_StaySignedIn',
		defaultMessage: 'Stay Signed In'
	},
	loading: {
		id: 'CcfPwa_Loading',
		defaultMessage: 'Loading...'
	},
	close: {
		id: 'CcfPwa_Close',
		defaultMessage: 'Close'
	},
	syncCollections: {
		id: 'CcfPwa_SyncCollections',
		defaultMessage: 'Sync {unsyncedCollections} Records'
	},
	version: {
		id: 'CcfPwa_VersionLabel',
		defaultMessage: 'Version'
	},
	noChangelogDetails: {
		id: 'CcfPwa_ChangelogNotFound',
		defaultMessage: 'No changelog details found.'
	},
	previousUpdates: {
		id: 'CcfPwa_PreviousUpdates',
		defaultMessage: 'Previous Updates'
	},
	search: {
		id: 'CollectionDashboard_Search',
		defaultMessage: 'Search'
	},
	clear: {
		id: 'CollectionDashboard_ClearButtonText',
		defaultMessage: 'Clear'
	},
	showActiveOnly: {
		id: 'CcfPwa_ShowActiveOnly',
		defaultMessage: 'Show Active Only'
	},
	showInactive: {
		id: 'CcfPwa_ShowInactive',
		defaultMessage: 'Show Inactive'
	},
	addUser: {
		id: 'ManageUsers_AddUser',
		defaultMessage: 'Add User'
	},
	edit: {
		id: 'ProfileUser_EditButtonText',
		defaultMessage: 'Edit'
	},
	notAvailableOfflineTitle: {
		id: 'CcfPwa_NotAvailableOfflineTitle',
		defaultMessage: 'Page Not Available Offline'
	},
	notAvailableOffline: {
		id: 'CcfPwa_NotAvailableOffline',
		defaultMessage: 'This page is not available for use online. Please return to the '
	},
	dashboard: {
		id: 'NewCcf_GoToDashboard',
		defaultMessage: 'Dashboard'
	},
	orCreate: {
		id: 'CcfPwa_OrCreate',
		defaultMessage: ' or create a '
	},
	newCollection: {
		id: 'CcfPwa_NewCollection',
		defaultMessage: 'New Collection'
	},
	isRequired: {
		id: 'CcfPwa_IsRequired',
		defaultMessage: 'is required.'
	},
	errorHasOccurred: {
		id: 'CcfPwa_ErrorOccurred',
		defaultMessage: 'An error has occurred'
	},
	selectPlaceholder: {
		id: 'CcfPwa_SelectPlaceholder',
		defaultMessage: 'Select...'
	},
	selectAtLeastOne: {
		id: 'CcfPwa_SelectAtLeastOne',
		defaultMessage: 'At least one of these fields must be selected.'
	}
});
